module.exports = __webpack_public_path__ + "dist/media/logo--fr.5561aed2.svg";